import type { FC, ReactNode } from "react";

import type { BuilderBlock, BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks, isEditing } from "@builder.io/sdk-react";

import { ArticleRestrictedContent as UIArticleRestrictedContent } from "@jti/loyalty/components/ArticleRestrictedContent";

import { BlogRelatedArticles } from "../BlogRelatedArticles/BlogRelatedArticles";

import type { articleRestrictedContentInputs } from "./ArticleRestrictedContent.builder";

type ArticleRestrictedContentBuilderProps = BuilderComponentProps<typeof articleRestrictedContentInputs> & {
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
};

export const ArticleRestrictedContent: FC<ArticleRestrictedContentBuilderProps> = ({
  title,
  subtitle,
  articleType,
  controlColor,
  articleId,
  image,
  restrictImage,
  video,
  headerMediaType,
  creationDate,
  relatedArticles,
  relatedArticlesTitle,
  relatedArticlesCtaLabel,
  relatedArticlesCtaUrl,
  previewContent,
  primaryBtnUrl,
  primaryBtnUrlRestricted,
  secondaryBtnUrl,
  disableTiers,
  builderBlock,
  builderContext,
  builderComponents,
  percentageToWatch,
  quizBannerContent,
  quizContent,
}) => {
  const article = {
    title,
    subtitle,
    controlColor,
    articleType,
    articleId,
    image,
    video,
    headerMediaType,
    creationDate,
  };

  return (
    <>
      <UIArticleRestrictedContent
        previewContent={previewContent}
        primaryBtnUrl={primaryBtnUrl}
        primaryBtnUrlRestricted={primaryBtnUrlRestricted}
        restrictImage={restrictImage ?? null}
        secondaryBtnUrl={secondaryBtnUrl}
        article={article}
        richTextComponent={({ text }: { text: ReactNode }) => <div>{text}</div>}
        isInEditor={isEditing()}
        disableTiers={disableTiers}
        percentageToWatch={percentageToWatch ? +percentageToWatch : undefined}
        quizBannerContent={quizBannerContent}
        quizContentConfig={quizContent}
      >
        {builderBlock?.children?.map((child) => (
          <Blocks
            key={child.id}
            blocks={[child]}
            parent={builderBlock?.id}
            path="children"
            context={builderContext}
            registeredComponents={builderComponents}
          />
        ))}
      </UIArticleRestrictedContent>
      {relatedArticles && relatedArticles.length > 0 && (
        <BlogRelatedArticles
          relatedArticlesTitle={relatedArticlesTitle}
          relatedArticlesCtaLabel={relatedArticlesCtaLabel}
          relatedArticlesCtaUrl={relatedArticlesCtaUrl}
          relatedArticles={relatedArticles}
          isLoyalty={true}
        />
      )}
    </>
  );
};
